
import { FastingProtocol } from "@/types/fasting";

/**
 * Tracks fasting progress in Google Analytics
 */
export const trackFastingProgress = (state: {
  isActive: boolean;
  timeElapsed: number;
  selectedProtocol: FastingProtocol;
}): void => {
  // Track fasting progress in Google Analytics
  if (typeof window.gtag !== 'undefined' && state.isActive) {
    const progressPercent = Math.floor((state.timeElapsed / (state.selectedProtocol.durationHours * 60 * 60)) * 100);
    
    // Only track at meaningful intervals (every 10%)
    if (progressPercent % 10 === 0 && progressPercent > 0) {
      window.gtag('event', 'fasting_progress', {
        'protocol': state.selectedProtocol.name,
        'duration_hours': state.selectedProtocol.durationHours,
        'progress_percent': progressPercent,
        'elapsed_hours': Math.floor(state.timeElapsed / 3600)
      });
    }
  }
};

/**
 * Tracks fast completion/cancellation in Google Analytics
 */
export const trackFastEnd = (): void => {
  if (window.gtag) {
    window.gtag('event', 'fast_ended');
  }
};
